export const ProposalStatus = {
        Draft           : 1,	// Черновик
        Created         : 2,	// Входящая заявка
        Expertise       : 3,	// На экспертизе
        Statement       : 4,	// На утверждении
        Approve         : 5,	// Принята
        Modification    : 6,	// На доработке
        Scheduled       : 7,	// Назначено время
        Need_report     : 8,	// Ожидает отчета
        Done            : 9,	// Выполнена
        Publication     : 10,	// Статья
        Reject          : 11,	// Отклонена
        Deleted         : 12	// Удалена
    }
    
//         // export const ProposalStatusList = [
//     ProposalStatusList: [
//     { status_id: 1, slug: 'draft', name: this.$t('ModeratorList.applications_still_being_formed'), page: 1 },
//     { status_id: 2, slug: 'created', name: this.$t('ModeratorList.incoming_requests'), page: 1 },
//     { status_id: 3, slug: 'expertise', name: this.$t('ModeratorList.on_examination'), page: 1 },
//     { status_id: 4, slug: 'statement', name: this.$t('ModeratorList.expert_advice'), page: 1 },
//     { status_id: 5, slug: 'approve', name: this.$t('ModeratorList.adopted'), page: 1 },
//     { status_id: 6, slug: 'modification', name: this.$t('ModeratorList.on_completion'), page: 1 },
//     { status_id: 7, slug: 'scheduled', name: this.$t('ModeratorList.experiment_planned'), page: 1 },
//     { status_id: 8, slug: 'need_report', name: this.$t('ModeratorList.awaiting_report'), page: 1 },
//     { status_id: 9, slug: 'done', name: this.$t('ModeratorList.completed'), page: 1 },
//     { status_id: 10, slug: 'publication', name: this.$t('ModeratorList.there_publication'), page: 1 },
//     { status_id: 12, slug: 'deleted', name: this.$t('ModeratorList.deleted'), page: 1 },
//     { status_id: 11, slug: 'reject', name: this.$t('ModeratorList.rejected'), page: 1 },
//   ]